import React, { Component } from "react";
import { MDBDataTable } from "mdbreact";

// Router
import { NavLink, withRouter } from "react-router-dom";

//Redux
import { connect } from "react-redux";
import { getFunderNotifications } from "../../redux/actions/funders";
import { showModal } from "../../redux/actions/modal";

//Table Helpers
import { attachActionButtons } from "../../helpers/tableControllers";

// UI Components
import { Loader, InfoLoader } from "../../UI/Loaders/Loaders";

// Component Styles
import "./FunderNotifications.css";

export class Notifications extends Component {
  // Component StateFunder
  state = {
    tabs: [
      // Tabs array passed as props to the Tabs UI Component to configure & display
      {
        identifier: "notificationTab",
        name: "All",
        id: "all",
        icon: "fas fa-hourglass-start",
      },
      {
        identifier: "notificationTab",
        name: "Repayments",
        id: "repayments",
        icon: "fas fa-hourglass-start",
      },
      {
        identifier: "notificationTab",
        name: "Disbursements",
        id: "disbursements",
        icon: "fas fa-check-circle",
      },
      {
        identifier: "notificationTab",
        name: "Payouts",
        id: "payouts",
        icon: "fas fa-times-circle",
      },
      {
        identifier: "notificationTab",
        name: "Fund Wallet",
        id: "fundwallet",
        icon: "fas fa-ban",
      },
    ],
  };

  // Open Modal
  modalHandler = (modalData) => {
    this.props.showModal(modalData);
  };

  //  Life Cycle Hooks
  componentDidMount() {
    //  If user is not authenticates, redirect to login
    if (!this.props.isAuthenticated) {
      this.props.history.push("/login");
    }

    //  On Mount, get Notification data from API to render in the UI
    //  Notification data: An object with two properties - columns & rows
    this.props.getFunderNotifications();
  }

  //JSX Template
  render() {
    let { notificationsTableData, loading, error } =
      this.props.funderNotifications;

    let RenderedComponent = null;

    if (loading || notificationsTableData === null) {
      RenderedComponent = <Loader text="Notifications" />;
    } else if (error || notificationsTableData === undefined) {
      RenderedComponent = (
        <div className="mt-40 tfx-user-form-wrapper box-effect full-border white-bg animated fadeInRight">
          <InfoLoader
            text="There was an issue fetching your notification."
            subText="Kindly reload the page."
          />
        </div>
      );
    } else if (notificationsTableData.rows) {
      if (notificationsTableData.rows.length !== 0) {
        const tableName = "Notifications";
        const actions = ["view"];
        let rowsWithActionButton = attachActionButtons(
          notificationsTableData.rows,
          tableName,
          actions,
          this.modalHandler
        );
        notificationsTableData = {
          ...notificationsTableData,
          rows: [...rowsWithActionButton],
        };
      }
      RenderedComponent = (
        <div className="grid__padding">
          <MDBDataTable
            responsive
            minimal="true"
            striped
            bordered
            hover
            data={notificationsTableData}
          />
        </div>
      );
    } else {
      RenderedComponent = (
        <div className="centerLoader">
          <div className="mt-40 tfx-user-form-wrapper box-effect full-border white-bg animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There are Currently No Notifications
              to View
            </h4>
          </div>
        </div>
      );
    }

    return (
      <div className="FunderNotifications datatable-wrapper">
        <div className="table-view speed-1x fadeInRight">
          {/*Notification Header*/}
          <div className="block-header">
            <div className="row">
              <div className="col-lg-12 col-md-6 col-sm-7 dashboard-title flex__row">
                <h3 className="m-l-1">
                  <aside className="rounder">
                    <i className="fas fa-credit-card" />
                  </aside>
                  &nbsp; Notifications
                </h3>

                <div className="breadcrumb__location">
                  <NavLink to="dashboard">
                    <h3 className="breadcrumb__location__title">Dashboard</h3>
                  </NavLink>
                  <span className="breadcrumb__location__icon">
                    <i className="fas fa-angle-double-right" />
                  </span>
                  <NavLink to="funder-notification">
                    <h3 className="breadcrumb__location__title">
                      Notifications
                    </h3>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>

          {/* All Notifications Datatable || Loader || Error Message*/}
          {RenderedComponent}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({
  authReducer,
  fundersReducer: { funderNotifications },
}) => {
  const { isAuthenticated, loggedInUser } = authReducer;

  return {
    isAuthenticated,
    loggedInUser,
    funderNotifications,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    getFunderNotifications,
    showModal,
  })(Notifications)
);
